import { render, staticRenderFns } from "./deivce-report-tab.vue?vue&type=template&id=6b625a19"
import script from "./deivce-report-tab.vue?vue&type=script&lang=js"
export * from "./deivce-report-tab.vue?vue&type=script&lang=js"
import style0 from "./deivce-report-tab.vue?vue&type=style&index=0&id=6b625a19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports